import { mixpanel } from './config/mixpanelConfig';

export const resetTracking = () => {
  mixpanel.reset();
};
